export default __webpack_public_path__ + "static/es-75cecdacf2997c9fcf6182daab04447d.jpg";